import type { JSX } from 'react';

import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { css, cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { BaseStyle, Color, FlexDirection, Font, FontWeight, Spacing, TextAlign } from 'src/styles';

import { MFormItemError } from '../MFormItemError/MFormItemError';

export const titleColStyle = (type: 'error' | 'success') => css`
  color: ${type === 'error' ? Color.Red6 : Color.Green6};
  ${FontWeight.bold}
  ${TextAlign.center}
  ${Font.lg}
  ${Spacing.my12}
  ${BaseStyle.level}
  ${FlexDirection.column}
`;

export const messageSpanStyle = css`
  ${Font.md}
  ${TextAlign.center}
  color: ${Color.Gray7};
`;

export const submissionResultRowStyle = css`
  width: 100%;
`;

interface SubmissionResultProps {
  type: 'success' | 'error';
  title?: string;
  message?: string | JSX.Element;
  testId?: string;
}

export const SubmissionResult = ({
  type,
  title = type === 'error' ? 'Submission Failed' : 'Submission Succeeded',
  message,
  testId,
}: SubmissionResultProps) => {
  return (
    <Row className={submissionResultRowStyle}>
      <Col span={24} className={titleColStyle(type)}>
        {type === 'error' ? <ExclamationCircleOutlined /> : <CheckCircleOutlined />}
        <span data-testid={`submission-${testId}-title`}>{title}</span>
      </Col>
      <Col span={24} className={cx(Spacing.my12, type === 'success' ? TextAlign.center : TextAlign.left)}>
        {type === 'error' ? (
          <MFormItemError value={message} testId={`submission-${testId}-error`} />
        ) : (
          <span className={messageSpanStyle} data-testid={`submission-${testId}-text-message`}>
            {message}
          </span>
        )}
      </Col>
    </Row>
  );
};
